import { useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { useLocale } from '@/hooks';
export const GClassRoomShareButton = (props: {
  entryMapHashId: string;
}) => {
  const {
    t
  } = useTranslation(['common']);
  const {
    locale
  } = useLocale();
  const shareButton = useRef<HTMLDivElement>(null);
  const handleClick = () => {
    shareButton.current?.click();
  };
  const openLink = () => {
    logger.track('classroom_share');
    const playUrl = `${window.location.origin}${locale === 'ko' ? '' : `/${locale}`}/play/${props.entryMapHashId}`;
    window.open(`https://classroom.google.com/u/0/share?url=${playUrl}&onsharecomplete=closeGoogleClassroom`, '_blank', 'width=600, height=700, toolbar=no, menubar=no, scrollbars=no, resizable=yes');
  };
  return <>
      <div className={'flex h-full min-w-[150px] cursor-pointer items-center gap-xs rounded-[8px] border border-gray-300 bg-white p-sm text-[12px] font-semibold text-gray-700'} onClick={handleClick}>
        <div ref={shareButton} className={'flex items-center'} id="classroom-share" data-size="18" onClick={openLink} />
        <Icon data-sentry-element="Icon" data-sentry-source-file="GClassRoomShareButton.tsx" />
        <span className={'flex h-full items-center'}>
          {t('common:global.button.googleClassRoom')}
        </span>
      </div>
    </>;
};
const Icon = () => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" data-sentry-element="svg" data-sentry-component="Icon" data-sentry-source-file="GClassRoomShareButton.tsx">
      <g clipPath="url(#clip0_2306_4658)" data-sentry-element="g" data-sentry-source-file="GClassRoomShareButton.tsx">
        <path d="M18 0H0V18H18V0Z" fill="#FFC112" data-sentry-element="path" data-sentry-source-file="GClassRoomShareButton.tsx" />
        <path d="M16.5 1.5H1.5V16.5H16.5V1.5Z" fill="#21A465" data-sentry-element="path" data-sentry-source-file="GClassRoomShareButton.tsx" />
        <path fillRule="evenodd" clipRule="evenodd" d="M13.5 8.25C13.5 7.83583 13.1642 7.5 12.75 7.5C12.3358 7.5 12 7.83583 12 8.25C12 8.66417 12.3358 9 12.75 9C13.1642 9 13.5 8.66417 13.5 8.25ZM12.75 9.375C11.6655 9.375 10.5 9.90729 10.5 10.5656V11.25H15V10.5656C15 9.90729 13.8345 9.375 12.75 9.375ZM6 8.25C6 7.83583 5.66417 7.5 5.25 7.5C4.83583 7.5 4.5 7.83583 4.5 8.25C4.5 8.66417 4.83583 9 5.25 9C5.66417 9 6 8.66417 6 8.25ZM5.25 9.375C4.1655 9.375 3 9.90729 3 10.5656V11.25H7.5V10.5656C7.5 9.90729 6.3345 9.375 5.25 9.375Z" fill="#57BB8A" data-sentry-element="path" data-sentry-source-file="GClassRoomShareButton.tsx" />
        <path fillRule="evenodd" clipRule="evenodd" d="M9.0012 8.25C9.62182 8.25 10.1253 7.74656 10.1253 7.125C10.1253 6.50438 9.62182 6 9.0012 6C8.37964 6 7.87526 6.50438 7.87526 7.125C7.87526 7.74656 8.37964 8.25 9.0012 8.25ZM6.06445 10.375V11.25H12.0003V10.375C12.0003 9.40813 10.4633 8.625 9.03236 8.625C7.6014 8.625 6.06445 9.40813 6.06445 10.375Z" fill="#F7F7F7" data-sentry-element="path" data-sentry-source-file="GClassRoomShareButton.tsx" />
        <path fillRule="evenodd" clipRule="evenodd" d="M10.5 15.375H15V16.5H10.5V15.375Z" fill="#F1F1F1" data-sentry-element="path" data-sentry-source-file="GClassRoomShareButton.tsx" />
      </g>
      <defs data-sentry-element="defs" data-sentry-source-file="GClassRoomShareButton.tsx">
        <clipPath id="clip0_2306_4658" data-sentry-element="clipPath" data-sentry-source-file="GClassRoomShareButton.tsx">
          <rect width="18" height="18" fill="white" data-sentry-element="rect" data-sentry-source-file="GClassRoomShareButton.tsx" />
        </clipPath>
      </defs>
    </svg>;
};